var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingsSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.41 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n        stroke-width: 2px;\n      }\n\n      .cls-2 {\n        fill: #756ab6;\n        stroke: #756ab6;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7",
    "data-name": "Layer 7"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "9.2 9 13.2 6 15.2 1 21.2 1 23.2 6 26.2 9 32.2 8 35.2 13 32.2 17 32.2 21 35.2 24.82 32.2 31 26.2 30 23.2 32 21.2 37 14.96 37 13.2 32 9.2 30 4.2 31 1.2 26 4.2 22 4.2 17 1.2 13 4.2 8 9.2 9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.23,14.06s-5.28,0-5.28,4.97,5.28,4.97,5.28,4.97c0,0,4.97,0,4.97-4.97s-4.97-4.97-4.97-4.97Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsSolid);
export default __webpack_public_path__ + "static/media/Settings-Solid.e58fd01d528e5c1d3f71174144fcc08f.svg";
export { ForwardRef as ReactComponent };